export const getVehicleImageUrl = (stockNumber: number) =>
  `${process.env.VEHICLE_IMAGE_CDN_URL}/${stockNumber}/post-large/${stockNumber}-edc-02-search.jpg`;

export const getCloseUpVehicleImageUrl = (stockNumber: number) =>
  `${process.env.VEHICLE_IMAGE_CDN_URL}/${stockNumber}/post-large/normalized/zoomcrop/${stockNumber}-edc-02.jpg`;
